module.exports = __webpack_public_path__ + "static/media/upgrade_tech.1ed2eccb.png";